import { read, utils, writeFile } from 'xlsx';

function fileToArrayBuffer(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      if (e.target) {
        resolve(e.target.result);
      } else {
        reject(new Error(`Unable to process ${e.type}`));
      }
    };
    reader.onerror = function (e) {
      reject(new Error(`Unable to process ${e.type}`));
    };
    reader.readAsArrayBuffer(file);
  });
}

export async function fileToWorkBook(file: File) {
  const arrayBuffer = await fileToArrayBuffer(file);
  const wb = read(arrayBuffer, { sheets: [0] });
  const sheet = wb.Sheets?.[wb.SheetNames[0]];
  const range = utils.decode_range(sheet['!ref'] ?? '');
  const columnCount = range.e.c + 1;
  const rowCount = range.e.r + 1;
  const headers: string[] = [];
  for (let i = 0; i < columnCount; ++i) {
    headers.push(sheet[`${utils.encode_col(i)}1`].v);
  }
  return {
    headers,
    rowCount,
  };
}

export function base64ToBlob(base64: string, type: string) {
  const byteCharacters = window.atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type });
}

export async function excelToJSON(
  file: File
): Promise<Record<string, string | number>[]> {
  const arrayBuffer = await fileToArrayBuffer(file);
  const wb = read(arrayBuffer, { sheets: [0] });
  return utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
}

export async function JSONToExcel(
  data: Record<string, string | number>[],
  fileName: string
) {
  const ws = utils.json_to_sheet(data);
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, 'Sheet1');
  writeFile(wb, fileName, { bookType: 'xlsx', type: 'array' });
}

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = globalThis.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  globalThis.URL.revokeObjectURL(url);
};
